import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { GET_ORGANIZATION_SCHEDULING_SETTINGS_QUERY_KEY } from '../queries/useGetOrganizationSchedulingSettings';
import type { OrganizationSchedulingSettingsInput } from '../../api/queries';

export const useUpdateOrganizationSchedulingSettingsMutation = () => {
  const queryClient = useQueryClient();
  const { updateCurrentOrganizationSchedulingSettings } = useServicesContext();

  return useMutation({
    mutationKey: ['UPDATE_ORGANIZATION_SCHEDULING_SETTINGS'],
    mutationFn: (settings: OrganizationSchedulingSettingsInput) =>
      updateCurrentOrganizationSchedulingSettings(settings),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ORGANIZATION_SCHEDULING_SETTINGS_QUERY_KEY],
      });
    },
  });
};
